import { render, staticRenderFns } from "./update_per_account_refunds.vue?vue&type=template&id=7af88832&"
import script from "./update_per_account_refunds.vue?vue&type=script&lang=js&"
export * from "./update_per_account_refunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports